import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  { path: '/', redirect: '/login' },

  {
    path: '/login',
    name: 'login',
    meta: { layout: "blank" },
    component: () => import('@/views/LoginPage.vue')
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import('@/views/HomeView.vue')
  },
  {
    path: '/popup',
    name: 'PopUp',
    component: () => import('@/views/pages/PopUp.vue')
  },
  {
    path: '/subscription-payment',
    name: 'Subscription Payment',
    component: () => import('@/views/pages/subscription_payment/SubscriptionPaymentList.vue')
  },
  {
    path: '/lom-title-payment',
    name: 'LO Title Payment',
    component: () => import('@/views/pages/payment/LomTitlePayment.vue')
  },
  {
    path: '/ledger',
    name: 'Ledger',
    component: () => import('@/views/pages/ledger/LedgerList.vue')
  },
  {
    path: '/transaction',
    name: 'Transaction',
    component: () => import('@/views/pages/transaction/TransactionList.vue')
  },
  {
    path: '/sma-subscription/list',
    name: 'SMA Subscription',
    component: () => import('@/views/pages/sma-subscription/SmaSubscriptionList.vue')
  },
  {
    path: '/foundation-payment-report',
    name: 'Foundation Payment Report',
    component: () => import('@/views/pages/foundation-payment/FoundationPaymentReport.vue')
  },
  {
    path: '/new-event-payment-list',
    name: 'NewEventPaymentList',
    component: () => import('@/views/pages/jci-program/JciProgramPaymentReport.vue')
  },
]

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    console.log({ to });
    console.log({ from });
    console.log({ savedPosition });
    return { x: 0, y: 0 }
  }
});

router.beforeEach(async (to, from, next) => {
  var ToName = to.name;
  console.log({ ToName });

  var fromPath = from.path;
  var toPath = to.path;
  console.log("navigation from=" + fromPath + ", to=" + toPath);

  var token = localStorage.getItem("token");
  token = token == (null || undefined) ? "" : token;
  console.log({ token });

  if (
    to.path == "/" ||
    to.path == "/login" ||
    to.path == "/*"
  ) {
    console.log("navigation true");
    next();
  } else {
    console.log("navigation false");
    if (token != "") {
      console.log("token is valid");
      next();
    } else {
      console.log("session is expired");
      router.push("/login");
    }
  }
});

export default router
